import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Seo from "../../Components/SeoComponent/Seo";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import {
  FaUniversity,
  FaBolt,
  FaWallet,
  FaClock,
  FaCheckCircle,
} from "react-icons/fa";
import { Button } from "../../Components/Tags/Tags";
import { CiBank } from "react-icons/ci";
import { numberToWords } from "../../utils";
import { verifyIfscCodeService } from "../../Services";
import {
  CreateSinglePayout,
  verifyBankPayout,
} from "../../Services/PayoutService.js/Payouts";
import Loader from "../../Loader";
import { fetchProfile } from "../../Services/profile/profileservice";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import html2pdf from "html2pdf.js";
import { IoMdDownload } from "react-icons/io";
import DataModal from "../../Components/ConfirmPopUp/DataModal";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";

const StatsData = [
  {
    icon: HiOutlineCurrencyRupee,
    title: "Instant 24/7 Payouts.",
  },
  {
    icon: FaUniversity,
    title: "Pay Via Linked Bank Accounts.",
  },
  {
    icon: FaWallet,
    title: "All Payments Modes.",
  },
  {
    icon: FaBolt,
    title: "Get Realtime insight.",
  },
  {
    icon: FaClock,
    title: "No Cool off Period.",
  },
  {
    icon: FaCheckCircle,
    title: "Quick Bank Accounts Verification.",
  },
];

const SinglePayout = () => {
  const [sendType, setSentType] = useState("bank");
  const [payamentMode, setPaymentMode] = useState("");
  const [amount, setAmout] = useState(0);
  const [ifscCode, setIfScCode] = useState("");
  const [ifscDetails, setIfscDetails] = useState(null);
  const [accountData, setAccountData] = useState({
    acc_no: "",
    conf_acc: "",
  });
  const [beneficiaryData, setBeneficiaryData] = useState({
    name: "",
    address: "",
    email: "",
    mobile: "",
    remarks: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenView, setIsOpenView] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [payoutAccount, setPayoutAccount] = useState("");
  const [slipData, setSlipData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const navigate = useNavigate();
  const [errorText, setErrorText] = useState({
    message: "",
    type: "error",
    field: "",
  });
  const [bankData, setBankData] = useState("");

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile(); // Your API call for profile
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  useEffect(() => {
    if (profileData?.payout_account?.account_number) {
      setPayoutAccount(profileData?.payout_account?.account_number || "");
    }
  }, [profileData]);

  async function verifyIfscCode() {
    setErrorText({
      message: "",
      type: "error",
      field: "",
    });
    if (ifscCode === "") {
      setIfscDetails(null);
      setErrorText({
        message: "",
        type: "error",
        field: "",
      });
      return;
    }
    let regex = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
    if (!regex.test(ifscCode)) {
      setIfscDetails(null);
      setErrorText({
        message: "X",
        type: "error",
        field: "IFSC",
      });
      return;
    }
    setErrorText({
      message: "✔",
      type: "success",
      field: "IFSC",
    });
    setIsLoading(true);
    let response = await verifyIfscCodeService(ifscCode);
    setIsLoading(false);
    setIfscDetails(response);
  }

  const handleVerifyAc = async () => {
    try {
      setIsLoading(true);

      const response = await verifyBankPayout({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        creditorAccountId: accountData?.conf_acc,
        ifscCode: ifscCode,
      });

      const statusCode = response?.status?.code || response?.status;

      if (statusCode === 200) {
        setBankData(response.data || response.data.data || "");
        showSuccessToast(
          response.message || "Bank account verified successfully.",
        );
        // setPayoutAccount("");
        // setIfScCode("");
      } else if (statusCode === 422) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            "Invalid bank format or data.",
        );
      } else if (statusCode === 403) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            "Invalid or deactivated API key.",
        );
      } else if (statusCode === 500) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            response.error.message ||
            "Server error occurred while fetching bank details.",
        );
      } else {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            response.error.message ||
            `Unexpected error occurred (code: ${statusCode})`,
        );
      }
    } catch (error) {
      console.error("Bank Details Error:", error);
      showErrorToast("Failed to verify bank details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  function validateFOrm() {
    if (ifscCode === "") {
      setIfscDetails(null);
      setErrorText({
        message: "X",
        type: "error",
        field: "IFSC",
      });
      return false;
    }
    if (amount === 0) {
      setErrorText({
        message: "Amount is required",
        type: "error",
        field: "AMOUNT",
      });
      return false;
    }

    if (accountData.acc_no !== accountData.conf_acc) {
      setErrorText({
        message: "Account doest not match",
        type: "error",
        field: "CONA",
      });
      return false;
    }
    if (beneficiaryData.name === "") {
      setErrorText({
        message: "Beneficiary name is required",
        type: "error",
        field: "BENEFICIARY_NAME",
      });
      return false;
    }
    if (accountData.acc_no === accountData.conf_acc) {
      setErrorText({
        message: "Account match success",
        type: "success",
        field: "CONA",
      });
      return true;
    }
    return true;
  }

  function handleSubmitFUnction() {
    if (validateFOrm() === true) {
      setIsOpenView(true);
    }
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAccountData((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleBeneficiaryChange = (event) => {
    const { name, value } = event.target;
    setBeneficiaryData((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handlePayoutSubmit = async () => {
    setIsLoading(true);
    try {
      const payoutData = {
        api_id: profileData.user_id || "",
        api_key: profileData.api_key || "",
        token_id: profileData.token_id || "",
        amount: String(amount),
        transactionType: payamentMode,
        paymentDescription:
          beneficiaryData.remarks || `Payment to ${beneficiaryData.name}`,
        creditAccountNumber: accountData.acc_no,
        remitterName: beneficiaryData.name || "",
        beneficiaryIFSC: ifscCode,
        beneficiaryName: beneficiaryData.name || "",
        beneficiaryAddress: beneficiaryData.address || "",
        emailId: beneficiaryData.email || "",
        mobileNo: beneficiaryData.mobile || "",
        payout_account_number: payoutAccount || "",
      };

      const response = await CreateSinglePayout(payoutData);

      if (response) console.log("payout response", response);

      if (
        response?.status === 200 ||
        response.status.code === 200 ||
        response.success !== false
      ) {
        showSuccessToast(response.message || "Payout created successfully!");
        setSlipData(response.data || response.data.data || []);

        // First close view modal
        setIsOpenView(false);

        // Delay opening slip modal to ensure proper transition
        setTimeout(() => {
          setIsOpen(true);
        }, 600); // Delay in ms
        resetForm();
      } else if (response?.status === 422) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            "Unprocessable Entity. Please check your input fields.",
        );
      } else if (response?.status === 403) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            "Unauthorized action. Please verify your credentials or session.",
        );
      } else if (response?.status === 500) {
        showErrorToast(
          response.message ||
            response?.data?.message ||
            "Internal server error. Please try again later.",
        );
      } else {
        const errorMsg =
          response?.message ||
          response?.data?.message ||
          response?.error?.message ||
          response?.status?.message ||
          "An unexpected error occurred.";
        showErrorToast(errorMsg);
      }
    } catch (error) {
      console.error("Payout creation error:", error);
      const errorMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "A network or server error occurred. Please try again.";
      showErrorToast(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setAmout(0);
    setIfScCode("");
    setIfscDetails(null);
    setAccountData({ acc_no: "", conf_acc: "" });
    setBeneficiaryData({
      name: "",
      address: "",
      email: "",
      mobile: "",
      remarks: "",
    });
    setErrorText({ message: "", type: "error", field: "" });
  };

  useEffect(() => {
    verifyIfscCode();
  }, [ifscCode]);

  useEffect(() => {
    if (accountData.acc_no === "") {
      setErrorText({
        message: "Account no is required",
        type: "error",
        field: "CONA",
      });
      return;
    }
    if (accountData.acc_no !== accountData.conf_acc) {
      setErrorText({
        message: "Account doest not match",
        type: "error",
        field: "CONA",
      });
      return;
    }
    if (accountData.acc_no === accountData.conf_acc) {
      setErrorText({
        message: "Account match success",
        type: "success",
        field: "CONA",
      });
      return;
    }
  }, [accountData.conf_acc]);

  const handleDownload = () => {
    const element = document.getElementById("txn-slip");

    const opt = {
      margin: 0,
      // filename: 'Slip.pdf',
      filename: `${slipData?.response?.initiateAuthGenericFundTransferAPIResp?.resourceData?.transactionID || "Slip"}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3,
        useCORS: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(opt).from(element).save();
    // setIsOpen(false);
  };

  useEffect(() => {
    if (
      bankData?.beneValidationResp?.resourceData?.creditorName &&
      !beneficiaryData.name
    ) {
      setBeneficiaryData((prev) => ({
        ...prev,
        name: bankData.beneValidationResp.resourceData.creditorName,
      }));
    }
  }, [bankData]);

  return (
    <div>
      {isLoading && <Loader />}
      <Header heading={"Payout Single"} />

      <Seo title={"Payout Single"} />

      <DataModal
        onClose={() => setIsOpenView(false)}
        visible={isOpenView}
        className="!p-0"
      >
        <div className="w-full rounded-md overflow-hidden bg-white">
          {/* Header */}
          <div className="bg-blue-900 text-white px-4 py-2 font-bold text-lg">
            Payment Confirmation
          </div>

          {/* Payment Info */}
          <div className="px-6 py-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-800">
              <p>
                <span className="font-semibold">Account:</span>{" "}
                {accountData.conf_acc}
              </p>
              <p>
                <span className="font-semibold">IFSC:</span> {ifscCode}
              </p>
              <p>
                <span className="font-semibold">Pay Amount:</span> ₹{amount}
              </p>
              <p>
                <span className="font-semibold">Beneficiary:</span>{" "}
                {beneficiaryData.name}
              </p>
              <p>
                <span className="font-semibold">Payment Mode:</span>{" "}
                {payamentMode}
              </p>
              <p>
                <span className="font-semibold">Amount in words:</span>{" "}
                {numberToWords(amount)} Rupees
              </p>
            </div>
          </div>

          {/* Optional PIN or note */}
          {/* <p className="text-center text-gray-600 font-medium -mt-4">Enter PIN to continue payment</p> */}

          {/* Footer Actions */}
          <div className="px-6 py-4 bg-gray-100 flex justify-end gap-4">
            <button
              type="button"
              className="bg-red-600 text-white px-5 py-2 rounded-md font-semibold hover:bg-red-700 transition duration-200 shadow-sm"
              onClick={() => setIsOpenView(false)}
            >
              Close
            </button>
            <button
              type="button"
              className={`bg-blue-700 text-white px-6 py-2 rounded-md font-semibold hover:bg-blue-800 transition duration-200 shadow-sm ${isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
              onClick={handlePayoutSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Processing..." : "Pay"}
            </button>
          </div>
        </div>
      </DataModal>

      <DataModal
        visible={isOpen}
        onClose={() => setIsOpen(false)}
        className="!p-0"
      >
        <div className="w-full max-w-7xl p-1 sm:p-2 md:p-1 bg-white rounded-lg shadow-2xl relative">
          <div
            className="bg-gray-50 rounded-xl shadow-inner p-1 space-y-1 border border-gray-200"
            id="txn-slip"
          >
            <h2 className="text-center text-2xl font-bold text-blue-700 border-b border-gray-300 pb-2">
              Transaction Slip
            </h2>

            {slipData ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-1 px-2 text-sm text-gray-800">
                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">Status:</span>
                  <br />
                  <span className="text-blue-600 font-medium">
                    {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                      ?.metaData?.status || "N/A"}
                  </span>
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">
                    Date & Time:
                  </span>
                  <br />
                  <span>
                    {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                      ?.metaData?.time
                      ? new Date(
                          slipData.response
                            .initiateAuthGenericFundTransferAPIResp.metaData
                            .time,
                        ).toLocaleString()
                      : "N/A"}
                  </span>
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">
                    Transaction ID:
                  </span>
                  <br />
                  {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                    ?.resourceData?.transactionID || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">UTR No:</span>
                  <br />
                  {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                    ?.resourceData?.transactionReferenceNo || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">
                    Transaction Status:
                  </span>
                  <br />
                  <span className="text-green-600 font-semibold">
                    {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                      ?.resourceData?.status || "N/A"}
                  </span>
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">
                    Txn Amount:
                  </span>
                  <br />
                  <span className="text-indigo-700 font-semibold">
                    ₹{slipData?.details?.amount || "N/A"}
                  </span>
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">IFSC:</span>
                  <br />
                  {slipData?.details?.ifsc_code || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border md:col-span-2">
                  <span className="font-semibold text-gray-600">
                    Beneficiary Name:
                  </span>
                  <br />
                  {slipData?.details?.beneficiary_name || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border md:col-span-2">
                  <span className="font-semibold text-gray-600">
                    Beneficiary Account:
                  </span>
                  <br />
                  {slipData?.creditAccountNumber || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">Message:</span>
                  <br />
                  {slipData?.response?.initiateAuthGenericFundTransferAPIResp
                    ?.metaData?.message || "N/A"}
                </div>

                <div className="bg-white px-2 py-1 rounded shadow-sm border">
                  <span className="font-semibold text-gray-600">Remarks:</span>
                  <br />
                  {slipData?.details?.remarks || "N/A"}
                </div>
              </div>
            ) : (
              <p className="text-center text-gray-500 italic">No Data Found</p>
            )}
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-center gap-2 mt-2">
            <button
              onClick={handleDownload}
              className="bg-blue-600 hover:bg-blue-800 text-white px-2 py-1 rounded-md shadow transition"
            >
              <IoMdDownload size={16} className="inline mr-1" /> Download
            </button>
            <button
              onClick={() => setIsOpen(false)}
              className="bg-red-500 hover:bg-red-700 text-white px-2 py-1 rounded-md shadow transition"
            >
              ✕ Close
            </button>
          </div>
        </div>
      </DataModal>

      <section className="flex my-1 flex-col sm:flex-row gap-1 items-start">
        <div className="w-full bg-white shadow-md h-screen p-1">
          <h2 className="text-3xl text-blue-900 font-bold leading-10 text-wrap break-before-page">
            Payouts Simplified for Businesses
          </h2>
          <p className="text-gray-400 leading-8 ">
            Make on-time payments to your vendors and process customer refunds
            with easy and accuracy.
          </p>
          <Button
            onClick={() => navigate("/payout/manage-beneficiary")}
            type={"button"}
            text={"Add Beneficiary"}
            className="!bg-blue-700 my-2 text-white py-1 px-2 font-bold text-md rounded-md"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mt-2">
            {StatsData.map((curr, index) => (
              <div
                key={index}
                className="flex flex-col items-start gap-1 justify-start transition transform hover:scale-105 duration-300 ease-in-out"
              >
                {curr.icon ? (
                  <curr.icon className="text-3xl  text-left text-sky-600 " />
                ) : (
                  <span style={{ fontSize: "2rem" }}>💸</span>
                )}
                <p className="text-left text-[15px] font-medium bg-gradient-to-r from-sky-500 to-blue-400 text-transparent bg-clip-text">
                  {curr.title}
                </p>
              </div>
            ))}
          </div>

          <div class="relative bg-white border-red-500 border-2 rounded-md shadow-md md:p-3 p-1 max-w-md mx-auto mt-6">
            <div class="absolute -top-7 left-0 bg-red-500 text-white text-sm font-semibold px-1 py-1 rounded-tl-xl rounded-tr-2xl  shadow-md">
              Security First :
            </div>
            <ul class="list-disc list-inside md:text-sm text-xs text-gray-700 space-y-1">
              <li className="font-semibold">
                Don't pay to anyone without verifying account details It may
                lead to loose your money.
              </li>
            </ul>
          </div>

          {payamentMode === "RTGS" && (
            <div className="mb-1 bg-white shadow-md rounded-lg p-2 border border-gray-200">
              <div className="mb-2">
                <h3 className="text-blue-700 text-xl font-bold border-b pb-2">
                  💳 RTGS (Real Time Gross Settlement)
                </h3>
              </div>
              <ul className="list-disc list-inside space-y-2 text-gray-800 text-sm leading-relaxed">
                <li>
                  <span className="font-semibold text-gray-900">
                    Eligibility:
                  </span>{" "}
                  RTGS is generally used for high-value transactions and is
                  available for both individuals and businesses.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Processing Time:
                  </span>{" "}
                  RTGS transactions are processed instantly but are subject to
                  banking hours (usually 9 AM to 4 PM on weekdays).
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Transaction Limit:
                  </span>{" "}
                  There is no upper limit for RTGS transactions, but a minimum
                  of ₹2 lakh is required.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Availability:
                  </span>{" "}
                  Available only during bank working hours. Transactions made
                  after working hours will be processed on the next working day.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">Security:</span>{" "}
                  RTGS is a secure method with encryption and real-time
                  processing for high-value transfers.
                </li>
              </ul>
            </div>
          )}

          {payamentMode === "NEFT" && (
            <div className="mb-2 bg-white shadow-md rounded-lg p-2 border border-gray-200">
              <div className="mb-2">
                <h3 className="text-green-700 text-xl font-bold border-b pb-2">
                  🏦 NEFT (National Electronic Funds Transfer)
                </h3>
              </div>
              <ul className="list-disc list-inside space-y-2 text-gray-800 text-sm leading-relaxed">
                <li>
                  <span className="font-semibold text-gray-900">
                    Eligibility:
                  </span>{" "}
                  NEFT is available for individuals, businesses, and government
                  payments. It can be used by anyone with a bank account.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Processing Time:
                  </span>{" "}
                  NEFT operates in hourly batches and typically takes 2–3 hours
                  for the money to reach the recipient's account. However, it
                  may take longer depending on the batch timings.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Transaction Limit:
                  </span>{" "}
                  No minimum or maximum limit, but large transfers may require
                  additional verification steps.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Availability:
                  </span>{" "}
                  Available on all days (except bank holidays), and payments are
                  processed during the working hours of the bank.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">Security:</span>{" "}
                  NEFT is a highly secure method for transferring funds with
                  encryption for both sender and recipient data.
                </li>
              </ul>
            </div>
          )}

          {payamentMode === "IMPS" && (
            <div className="mb-2 bg-white shadow-md rounded-lg p-2 border border-gray-200">
              <div className="mb-2">
                <h3 className="text-purple-700 text-xl font-bold border-b pb-2">
                  📲 IMPS (Immediate Payment Service)
                </h3>
              </div>
              <ul className="list-disc list-inside space-y-2 text-gray-800 text-sm leading-relaxed">
                <li>
                  <span className="font-semibold text-gray-900">
                    Eligibility:
                  </span>{" "}
                  IMPS can be used by anyone with a mobile phone or internet
                  banking. Available for both individuals and businesses.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Processing Time:
                  </span>{" "}
                  IMPS is a real-time, 24/7 transaction system. The transfer is
                  instant and processed immediately after submission.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Transaction Limit:
                  </span>{" "}
                  Typically, the maximum limit per transaction is ₹2 lakh
                  (depending on the bank’s policies).
                </li>
                <li>
                  <span className="font-semibold text-gray-900">
                    Availability:
                  </span>{" "}
                  Available 24/7, including holidays. Perfect for urgent or
                  small-value transfers.
                </li>
                <li>
                  <span className="font-semibold text-gray-900">Security:</span>{" "}
                  IMPS is very secure, using two-factor authentication (SMS/OTP)
                  and end-to-end encryption for each transaction.
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className=" bg-slate-50 shadow-md p-1">
          <div className="w-full">
            <div className="flex justify-between items-center px-2 py-2">
              {/* Left: Label and Input */}
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-700">
                  Payout Account No.
                </label>
                <input
                  id="accountSelect"
                  type="text"
                  value={payoutAccount}
                  readOnly
                  className="rounded border border-gray-400 outline-none px-2 py-1 bg-gray-100 cursor-not-allowed w-32"
                />
              </div>

              {/* Right: Balance */}
              <p className="text-sm font-semibold text-gray-600">
                Avl. Balance:{" "}
                <strong className="text-gray-800">
                  ₹{profileData?.payout_account?.balance || 0}
                </strong>
              </p>

              {/* Tooltip Wrapper */}
              <div className="relative group">
                <FaInfoCircle
                  className="cursor-pointer text-blue-700"
                  size={32}
                />

                {/* Tooltip */}
                <div className="absolute -translate-x-3/4 bottom-full w-60 bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50 text-center">
                  The Payout Account balance will be used to send money to
                  vendor, BBPS commission, Salary Payment only.
                </div>
              </div>
            </div>

            <div>
              <p>Send To</p>
              <div className="flex justify-start items-center gap-4 my-2">
                {/* Bank Option */}
                <div
                  className={`${sendType === "bank" ? "bg-blue-100" : "bg-white"} flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl cursor-pointer gap-2`}
                  onClick={() => setSentType("bank")}
                >
                  <CiBank />
                  <p>Bank</p>
                </div>

                {/* Wallet Option */}
                <div
                  className={`${sendType === "wallet" ? "bg-blue-100" : "bg-white"} flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl cursor-pointer gap-2 `}
                  // onClick={() => setSentType('wallet')

                  // }
                >
                  <span>💰</span>
                  <p>Wallet</p>
                </div>

                {/* UPI Option */}
                <div
                  className={`${sendType === "upi" ? "bg-blue-100" : "bg-white"} flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl cursor-pointer gap-2`}
                  // onClick={() => setSentType('upi')}
                >
                  <span>📱</span>
                  <p>UPI</p>
                </div>
              </div>

              <div className="flex justify-start gap-3 ">
                <div
                  className={`${errorText.field === "IFSC" ? (errorText.type === "error" ? "border-red-600" : "border-green-600") : ""} flex border items-center  px-2 border-gray-400 rounded  bg-white shadow-sm  `}
                >
                  <input
                    type="text"
                    className="h-10 font-semibold  outline-none uppercase px-2  "
                    placeholder="Enter IFSC"
                    value={ifscCode}
                    onChange={(e) => setIfScCode(e.target.value)}
                    maxLength={11}
                    max={11}
                  />
                  <span
                    className={`${errorText.field === "IFSC" ? (errorText.type === "error" ? "text-red-600" : "text-green-600") : ""} font-bold`}
                  >
                    {errorText.field === "IFSC" ? errorText.message : ""}{" "}
                  </span>
                </div>
                <div>
                  {ifscDetails !== null ? (
                    <>
                      <p className="text-xs font-semibold text-nowrap">
                        Bank :{ifscDetails?.BANK}
                      </p>
                      <p className="text-xs font-semibold text-nowrap">
                        Branch :{ifscDetails?.BRANCH}
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="flex gap-2 items-start justify-start my-2 ">
                <input
                  type="password"
                  className="border border-gray-400 rounded outline-none bg-white shadow-sm font-semibold  px-2 py-2 w-2/5"
                  placeholder="Beneficiary Account"
                  name="acc_no"
                  value={accountData.acc_no}
                  onChange={handleChange}
                />
                <div className="w-[55%] ">
                  <div className="flex  ">
                    <input
                      type="text"
                      className="border border-gray-400 rounded-l outline-none bg-white shadow-sm font-semibold  px-2 py-2 w-full"
                      placeholder="Confirm Account"
                      name="conf_acc"
                      value={accountData.conf_acc}
                      onChange={handleChange}
                    />
                    <button
                      onClick={handleVerifyAc}
                      className="border border-gray-400 border-l-0 rounded-r bg-blue-500 text-white font-bold px-4 py-1 hover:bg-blue-600"
                    >
                      Verify
                    </button>
                  </div>
                  <span
                    className={`${errorText.field === "CONA" ? (errorText.type === "error" ? "text-red-600" : "text-green-600") : ""} `}
                  >
                    {errorText.field === "CONA" ? errorText.message : ""}{" "}
                  </span>
                  <p className="text-right ">
                    Creditor Name:{" "}
                    {bankData?.beneValidationResp?.resourceData?.creditorName ||
                      "N/A"}
                  </p>
                </div>
              </div>

              {/* Beneficiary Details */}
              <div className="my-1">
                <input
                  type="text"
                  className="border border-gray-400 rounded-md outline-none bg-white shadow-sm font-semibold px-2 py-2 w-full mb-2"
                  placeholder="Beneficiary Name"
                  name="name"
                  value={beneficiaryData.name || ""}
                  onChange={handleBeneficiaryChange}
                />

                {/* <span className={`${errorText.field === 'BENEFICIARY_NAME' ? errorText.type === 'error' ? 'text-red-600' : 'text-green-600' : ''} `}>{errorText.field === 'BENEFICIARY_NAME' ? errorText.message : ''} </span> */}

                <input
                  type="text"
                  className="border border-gray-400 rounded-md outline-none bg-white shadow-sm font-semibold px-2 py-1 w-full mb-2"
                  placeholder="Beneficiary Address"
                  name="address"
                  value={beneficiaryData.address}
                  onChange={handleBeneficiaryChange}
                />

                <input
                  type="text"
                  className="border border-gray-400 rounded-md outline-none bg-white shadow-sm font-semibold px-2 py-1 w-full mb-2"
                  placeholder="Mobile Number"
                  name="mobile"
                  value={beneficiaryData.mobile}
                  onChange={handleBeneficiaryChange}
                />
              </div>
            </div>
            <div className="my-2">
              <input
                type="number"
                className="border border-gray-400 rounded-md outline-none bg-white shadow-sm font-bold text-xl px-2 py-2 w-full"
                value={amount === 0 ? "" : amount}
                onChange={(e) => {
                  const value = e.target.value;
                  setAmout(value);

                  const balance = Number(
                    profileData?.payout_account?.balance || 0,
                  );
                  const numericValue = Number(value);

                  let exceededLimit = false;

                  if (payamentMode === "IMPS" && numericValue > 500000) {
                    exceededLimit = true;
                  }

                  if (payamentMode === "NEFT" && numericValue > 1000000) {
                    exceededLimit = true;
                  }

                  if (numericValue > balance || exceededLimit) {
                    setShowMessage(true);
                  } else {
                    setShowMessage(false);
                  }
                }}
                onBlur={() => setShowMessage(false)}
                placeholder="Amount (₹)"
              />

              <span className="text-xs text-gray-600 font-bold">
                {amount > 0 ? numberToWords(amount) : ""}
              </span>

              {showMessage && (
                <p className="text-red-600 text-sm mt-1">
                  {Number(amount) > Number(profileData?.payout_account?.balance)
                    ? `Insufficient balance (₹${profileData?.payout_account?.balance})`
                    : payamentMode === "IMPS" && Number(amount) > 500000
                      ? "IMPS transfer limit is ₹5,00,000"
                      : payamentMode === "NEFT" && Number(amount) > 1000000
                        ? "NEFT transfer limit is ₹10,00,000"
                        : ""}
                </p>
              )}

              <span
                className={`${errorText.field === "AMOUNT" ? (errorText.type === "error" ? "text-red-600" : "text-green-600") : ""} font-bold`}
              >
                {errorText.field === "AMOUNT" ? errorText.message : ""}{" "}
              </span>
            </div>
            <div className="flex justify-start gap-4 my-3 px-2">
              {/* IMPS Button */}
              <button
                className={`${
                  payamentMode === "IMPS" ? "bg-blue-100" : "bg-white"
                } flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl cursor-pointer`}
                onClick={() => setPaymentMode("IMPS")}
              >
                IMPS
              </button>

              {/* NEFT Button */}
              <button
                className={`${
                  payamentMode === "NEFT" ? "bg-blue-100" : "bg-white"
                } flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl cursor-pointer`}
                onClick={() => setPaymentMode("NEFT")}
              >
                NEFT
              </button>

              {/* RTGS Button (conditionally disabled if amount < 2L) */}
              <button
                disabled={amount < 200000}
                title={
                  amount < 200000 ? "Minimum ₹2,00,000 required for RTGS" : ""
                }
                className={`${
                  payamentMode === "RTGS" ? "bg-blue-100" : "bg-white"
                } flex justify-center items-center rounded-md shadow-md py-1 px-5 text-xl 
      ${amount < 200000 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                onClick={() => amount >= 200000 && setPaymentMode("RTGS")}
              >
                RTGS
              </button>
            </div>

            <p className="text-gray-500  ">
              Max ₹5 lakh per transaction ,real-time credit, works 24/7.
            </p>
            <div className="flex  gap-3 my-2">
              <input
                type="text"
                className="border border-gray-400 rounded-md outline-none bg-white shadow-sm  px-2 py-2 w-full"
                placeholder="Remarks (optional)"
                name="remarks"
                value={beneficiaryData.remarks}
                onChange={handleBeneficiaryChange}
              />
              <input
                type="email"
                className="border border-gray-400 rounded-md outline-none bg-white shadow-sm px-2 py-2 w-full"
                placeholder="Beneficiary Email"
                name="email"
                value={beneficiaryData.email}
                onChange={handleBeneficiaryChange}
              />
            </div>
            <button
              type={"button"}
              onClick={handleSubmitFUnction}
              className="!bg-blue-800 my-2 text-white py-2 px-4 font-bold text-xl rounded-md w-full"
            >
              Proceed
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SinglePayout;
